import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import slide3 from '../aseets/images/home/slide3.jpg';
import { useSettings } from '../contexts/SettingsContext';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const { settings, isLoading } = useSettings();
  
  // Valeur par défaut si les paramètres sont en cours de chargement
  const contactEmail = isLoading ? 'info@medagricycle.eu' : (settings.email || 'info@medagricycle.eu');

  return (
    <>
      <Navbar />
      <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059" style={{
        backgroundImage: `url(${slide3})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}>
        <div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type">
          <div class="jet-theme-core-document__inner">
            <article id="post-4059" class="post-4059 page type-page status-publish hentry">	
              <div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
                <section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-widget_type="jet-slider.default">
                          <div class="elementor-widget-container">
                           
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                
      <div style={{
        minHeight: 'calc(100vh - 200px)',
        padding: '80px 20px 60px',
        maxWidth: '1200px',
        margin: '50px auto',
        fontFamily: 'Inter, sans-serif',
        position: 'relative'
      }}>
  <div style={{ inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
                                  <div style={{ background: 'rgba(0,0,0,0.45)', padding: '16px 24px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.25)', backdropFilter: 'blur(2px)', maxWidth: '960px', width: '100%' }}>
                                    <h1 style={{ color: '#fff', fontSize: 'clamp(34px,6vw,56px)', fontWeight: 800, margin: 0, textAlign: 'center', letterSpacing: '0.5px' }}>
            {t('privacyPolicy.title', 'Privacy Policy')}
          </h1>
                                  </div>
                                </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '16px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          lineHeight: '1.8',
          color: '#333',
          backdropFilter: 'blur(5px)'
        }}>
         

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('privacyPolicy.introduction', 'Introduction')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('privacyPolicy.introductionText', 'MedAgriCycle is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('privacyPolicy.dataCollection', 'Data We Collect')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('privacyPolicy.dataCollectionText', 'We may collect information about you in a variety of ways. The information we may collect includes:')}
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px', fontSize: '1.1rem' }}>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.data1', 'Personal data such as name, email address, and contact information when you contact us')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.data2', 'Usage data including your IP address, browser type, and pages visited')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.data3', 'Cookies and tracking technologies')}</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('privacyPolicy.howWeUse', 'How We Use Your Data')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('privacyPolicy.howWeUseText', 'We use the information we collect to:')}
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px', fontSize: '1.1rem' }}>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.use1', 'Provide, operate, and maintain our website')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.use2', 'Improve, personalize, and expand our website')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.use3', 'Understand and analyze how you use our website')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.use4', 'Respond to your inquiries and provide customer support')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.use5', 'Send you updates and communications related to the project')}</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('privacyPolicy.dataSharing', 'Data Sharing and Disclosure')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('privacyPolicy.dataSharingText', 'We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:')}
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px', fontSize: '1.1rem' }}>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.share1', 'With project partners for research and project management purposes')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.share2', 'When required by law or to protect our rights')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.share3', 'With service providers who assist us in operating our website')}</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('privacyPolicy.dataSecurity', 'Data Security')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('privacyPolicy.dataSecurityText', 'We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('privacyPolicy.yourRights', 'Your Rights')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('privacyPolicy.yourRightsText', 'Under GDPR and applicable data protection laws, you have the right to:')}
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px', fontSize: '1.1rem' }}>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.right1', 'Access your personal data')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.right2', 'Rectify inaccurate data')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.right3', 'Request deletion of your data')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.right4', 'Object to processing of your data')}</li>
              <li style={{ marginBottom: '10px' }}>{t('privacyPolicy.right5', 'Data portability')}</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('privacyPolicy.contact', 'Contact Us')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('privacyPolicy.contactText', 'If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at:')}
            </p>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              <strong>Email:</strong> {contactEmail}
            </p>
          </section>

          <p style={{ 
            marginTop: '40px', 
            paddingTop: '20px', 
            borderTop: '2px solid #e5e7eb',
            fontSize: '0.9rem',
            color: '#6b7280',
            fontStyle: 'italic'
          }}>
            {t('privacyPolicy.lastUpdated', 'Last updated:')} {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;

